module.exports = __webpack_public_path__ + "static/media/banner.b45fb444.svg";